import FadeIn from "../components/FadeIn";
import { ME } from "../constants/portfolioData";

/**
 * StackSection
 * Displays the tech stack grouped by category in a responsive grid.
 */
const StackSection = () => {
  return (
    <>
      <style>{`
        #stack { background: var(--bg2); }
        .stack-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.25rem; }
        .stack-group { background: var(--bg3); border: 1px solid var(--border); border-radius: 10px; padding: 1.5rem; }
        .sg-title { font-family: 'IBM Plex Mono', monospace; font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.15em; color: var(--muted); margin-bottom: 1rem; display: flex; align-items: center; gap: 0.4rem; }
        .sg-title::before { content: ''; display: inline-block; width: 6px; height: 6px; background: var(--accent); border-radius: 50%; }
        .sg-tags { display: flex; flex-wrap: wrap; gap: 0.45rem; }
        .sg-tag { font-family: 'IBM Plex Mono', monospace; font-size: 0.78rem; color: var(--muted2); padding: 0.35rem 0.75rem; background: var(--bg2); border: 1px solid var(--border2); border-radius: 6px; transition: all 0.2s; cursor: default; }
        .sg-tag:hover { color: var(--accent2); border-color: var(--accent2); background: var(--accent-dim); }
      `}</style>

      <section id="stack">
        <div className="wrap">
          <FadeIn><div className="sec-eyebrow">Tech Stack</div></FadeIn>
          <FadeIn delay={0.05}>
            <h2 className="sec-title">Tools I trust <em>in production</em></h2>
          </FadeIn>
          <FadeIn delay={0.1}>
            <p className="sec-sub">Technologies I've used at scale — not just side projects.</p>
          </FadeIn>

          <div className="stack-grid">
            {Object.entries(ME.techStack).map(([cat, tags], i) => (
              <FadeIn key={cat} delay={i * 0.07}>
                <div className="stack-group">
                  <div className="sg-title">{cat}</div>
                  <div className="sg-tags">
                    {tags.map((t) => (
                      <span key={t} className="sg-tag">{t}</span>
                    ))}
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default StackSection;